import React, { useState } from "react";
import { SummaryHeader } from "./components/SummaryHeader";
import { MainColumn } from "./components/MainColumn";
import { Sidebar } from "./components/Sidebar";
import { AdvancedDrawer } from "./components/AdvancedDrawer";
import { CreateLoanModal } from "./components/CreateLoanModal";
export function App() {
  const [isCreateLoanOpen, setIsCreateLoanOpen] = useState(false);
  return <div className="min-h-full w-full bg-slate-50 text-slate-900" data-id="element-0" data-mp="2rk41sqtu8cao">
      <SummaryHeader onCreateLoan={() => setIsCreateLoanOpen(true)} data-id="element-1" data-mp="2mluboumz01vx" />

      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6" data-id="element-2" data-mp="2mnne1xqjvzy4">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_360px]" data-id="element-3" data-mp="31bs1tg4gn1nr">
          <div className="space-y-5" data-id="element-4" data-mp="2wjgtppzkg9k4">
            <MainColumn data-id="element-5" data-mp="2wifbn1k4umsw" />
            <AdvancedDrawer data-id="element-6" data-mp="2wi5l9cv6edmo" />
          </div>
          <Sidebar onCreateLoan={() => setIsCreateLoanOpen(true)} data-id="element-7" data-mp="28te0v7ntuzkg" />
        </div>
      </main>

      <CreateLoanModal isOpen={isCreateLoanOpen} onClose={() => setIsCreateLoanOpen(false)} data-id="element-8" data-mp="23w4ey1znd61d" />
    </div>;
}